import {Component, Inject, OnInit, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {AlertsService} from "@app/services/misc-services/alerts.service";

@Component({
    selector: 'flex-export-table',
    templateUrl:'./export-table.component.html',
    styleUrls:['./export-table.component.css']
})
export class ExportTableComponent implements OnInit{
    columns: string[];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    displayedColumns: Array<{ label: string, value: string }>;
    fileName: string;
    closeDialog: boolean = false;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data, public alert: AlertsService) {}

    ngOnInit() {
        this.displayedColumns = this.data.displayedColumns;
        this.dataSource.data = this.data.selectedUsers;
        this.columns = this.displayedColumns.map(fieldName => fieldName.value);
        setTimeout(() => this.dataSource.paginator = this.paginator);
        setTimeout(() =>this.dataSource.sort = this.sort);

    }

    export() {
        this.downloadBlob(this.makeBlob());
    }
    makeBlob(){
        const selectedUsers = this.dataSource.filteredData;
        const replacer = (key, value) => (value ? value : ''); // specify how you want to handle null values here
        const header = this.displayedColumns.map(h => h.label);
        const csv = selectedUsers.map(row =>
            this.displayedColumns.map(fieldName => JSON.stringify(row[fieldName.value], replacer)).join(','),
        );
        csv.unshift(header.join(','));
        const csvArray = csv.join('\r\n');
        return new Blob([csvArray], {type: 'text/csv'});
    }
    downloadBlob(blob:Blob){
        if (this.fileName == null) {
            this.alert.getError('Please specify a file name.', 'X')
        } else {
            const activeUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = activeUrl;
            a.download = `${this.fileName}.csv`;
            a.click();
            window.URL.revokeObjectURL(activeUrl);
            a.remove();
            this.alert.getAlert('File downloaded!', 'X')
            this.dialogRef.close()
        }
    }
    onNoClick() {
        this.dialogRef.close();
    }
}
